<template>
    <div>
        <current-welds-table 
            ref="table" 
            :archived="1"
            :rowChangeSelectOptions="rowChangeSelectOptions"
            :columnData="columnData"
        >
        </current-welds-table>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import CurrentWeldsTable from '@/components/pages/project/welding/current_welds/current_welds_table.vue';

export default {
    name: 'current_welds_archived',
    components: {
        CurrentWeldsTable,
    },
    props: {
        rowChangeSelectOptions: {
            type: Object,
            default () {
                return null;
            },
        },
    },
    data() {
        return {
            columnData: [
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'drawing.line.line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'drawing.iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'drawing.page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.spool_no'),
                    field: 'spool.spool_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_class'),
                    field: 'drawing.line.line_class',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_material'),
                    field: 'weld_material.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_no'),
                    field: 'weld_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_type'),
                    field: 'project_setting.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_place'),
                    field: 'weld_place',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_date'),
                    field: 'welder_date_1',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder1'),
                    field: 'welder1.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.welder2'),
                    field: 'welder2.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.filler_material'),
                    field: 'filler_material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.ped_category'),
                    field: 'drawing.line.ped_category',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_size'),
                    field: 'weld_size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weld_dimension'),
                    field: 'weld_dimension',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'drawing_progress_status',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.inspection'),
                    field: 'inspection.value',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.rt'),
                    field: 'ndt_rt',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.vt'),
                    field: 'ndt_vt',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.pt'),
                    field: 'ndt_pt',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.ut'),
                    field: 'ndt_ut',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.mt'),
                    field: 'ndt_mt',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.pmi'),
                    field: 'ndt_pmi',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.pwht'),
                    field: 'ndt_pwht',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.bht'),
                    field: 'ndt_bht',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.at'),
                    field: 'ndt_at',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.fn'),
                    field: 'ndt_fn',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.others'),
                    field: 'ndt_others',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false,
                },
                {
                    label: Vue.i18n.translate('table.closed'),
                    field: 'current_weld_closed',
                    numeric: false,
                    html: false,
                    showAsCheckRed: true,
                },
            ],
        }
    },
    methods: {
        onLoadTable () {
            this.$refs.table.onLoadTable();
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/welding/current_welds/current_welds_archived.vue